import React from "react";
import { comingSoon } from "../assets/images";

const Sales = () => {
  return (
    <div className="mx-auto w-full max-w-[1400px] font-manrope">
      <h2 className="font-sora text-[24px] font-semibold text-foreground">
        Sales
      </h2>
      <div className="mt-10 flex h-[620px] w-full flex-col items-center justify-start rounded-xl bg-background px-6 pt-16 lgss:h-[600px] lgss:px-20">
        <img src={comingSoon} alt="" />
        <h2 className="mt-4 font-sora text-[20px] font-bold text-foreground">
          Coming Soon
        </h2>
        <p className="mt-4 text-center text-[14px] font-medium text-foreground">
          We are cooking something great for you. But you can join our WhatsApp
          group consisting of over 1,500 merchants worldwide to get exclusive
          benefits.
        </p>
        <a
          href="https://chat.whatsapp.com/K6wZTRSrG4GJM0jdCbRms4"
          target="_blank"
          rel="noreferrer"
          className="mt-4 flex h-[48px] w-[180px] items-center justify-center rounded-xl border border-primary text-[12px] font-medium text-primary"
        >
          Join WhatsApp Community
        </a>
      </div>
    </div>
  );
};

export default Sales;
